// src/App.js
// Enruta entre Login y Chat según si hay token.
// - Sin token: muestra <Login />
// - Con token: muestra <Chat /> y permite cerrar sesión
// - Sincroniza el token con localStorage
// - Maneja expiración de sesión (401) desde Chat via onSessionExpired

import { useEffect, useState } from 'react';
import Login from './components/Login';
import Chat from './components/Chat';

function App() {
  // Lee el token persistido al iniciar
  const [token, setToken] = useState(() => localStorage.getItem('token'));

  // Guarda/borra el token en localStorage cuando cambie
  useEffect(() => {
    if (token) localStorage.setItem('token', token);
    else localStorage.removeItem('token');
  }, [token]);

  // Callback que recibe Login cuando el backend devuelve el JWT
  const handleLoginSuccess = (newToken) => {
    setToken(newToken);
  };

  // Cerrar sesión manual
  const handleLogout = () => {
    setToken(null);
  };

  // Expiración automática: Chat llama esto si el backend responde 401
  const handleSessionExpired = () => {
    setToken(null);
    // Opcional: muestra un aviso
    // alert('Tu sesión expiró. Vuelve a iniciar sesión.');
  };

  // Render
  if (!token) {
    return <Login onLoginSuccess={handleLoginSuccess} />;
  }

  return (
    <div className="App">
      {/* Botón de salir opcional */}
      <button
        onClick={handleLogout}
        style={{ position: 'absolute', right: 12, top: 12 }}
      >
        Cerrar sesión
      </button>

      {/* Pasa el token y el handler de expiración al Chat */}
      <Chat token={token} onSessionExpired={handleSessionExpired} />
    </div>
  );
}

export default App;
